<script setup>
import { ref } from 'vue';
import ReportHeader from './components/ReportHeader.vue';
import CompanySummaryReports from './components/CompanySummaryReports.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const summaryReportsRef = ref(null);

const onDownloadClick = () => {
  summaryReportsRef.value?.downloadReports();
};
</script>

<template>
  <ReportHeader
    :header-title="$t('COMPANY_REPORTS.HEADER')"
    :header-description="$t('COMPANY_REPORTS.DESCRIPTION')"
  >
    <V4Button
      :label="$t('COMPANY_REPORTS.DOWNLOAD_COMPANY_REPORTS')"
      icon="i-ph-download-simple"
      size="sm"
      @click="onDownloadClick"
    />
  </ReportHeader>

  <CompanySummaryReports ref="summaryReportsRef" />
</template>
